import { useState, useEffect } from 'react';

export function CurrentTimeIndicator({ gridStartMinutes, gridTotalMinutes }) {
	const [currentMinutes, setCurrentMinutes] = useState(() => {
		const now = new Date();
		return now.getHours() * 60 + now.getMinutes();
	});

	useEffect(() => {
		const interval = setInterval(() => {
			const now = new Date();
			setCurrentMinutes(now.getHours() * 60 + now.getMinutes());
		}, 60000); // Update every minute

		return () => clearInterval(interval);
	}, []);

	// Check if current time is within the grid range
	const isInRange =
		currentMinutes >= gridStartMinutes &&
		currentMinutes <= gridStartMinutes + gridTotalMinutes;

	if (!isInRange) return null;

	const leftPercent =
		((currentMinutes - gridStartMinutes) / gridTotalMinutes) * 100;

	return (
		<div
			className="absolute top-0 bottom-0 z-10 pointer-events-none"
			style={{ left: `${leftPercent}%` }}
		>
			{/* Vertical line only */}
			<div className="absolute top-0 bottom-0 w-0.25 bg-indigo-500 left-1/2 -translate-x-1/2" />
		</div>
	);
}

// Hook to get current time in minutes, updating every minute
export function useCurrentTime() {
	const [currentMinutes, setCurrentMinutes] = useState(() => {
		const now = new Date();
		return now.getHours() * 60 + now.getMinutes();
	});

	useEffect(() => {
		const interval = setInterval(() => {
			const now = new Date();
			setCurrentMinutes(now.getHours() * 60 + now.getMinutes());
		}, 60000);

		return () => clearInterval(interval);
	}, []);

	return currentMinutes;
}
